import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type SkinnyLocationModel from 'garaje/models/skinny-location';
import type AuthzService from 'garaje/services/authz';
import type CurrentAdminService from 'garaje/services/current-admin';
import type StateService from 'garaje/services/state';
import { Permission } from 'garaje/utils/ui-permissions';

export default class GlobalLocationAbility extends Ability {
  @service declare currentAdmin: CurrentAdminService;
  @service declare skinnyLocations: SkinnyLocationModel;
  @service declare state: StateService;
  @service declare authz: AuthzService;

  get canVisit(): boolean {
    const isOnCorrectPlan = !!this.state.features?.canAccessGlobalOverview;
    const hasPermission = this.authz.hasAllPermissionsAtCurrentCompany([
      Permission.ACCOUNT_MANAGEMENT_LOCATION_READ,
      Permission.ACCOUNT_MANAGEMENT_LOCATION_CREATE,
      Permission.ACCOUNT_MANAGEMENT_LOCATION_UPDATE,
    ]);

    return isOnCorrectPlan && hasPermission;
  }
}
